// 统一请求路径前缀在commmon/axios.js中修改
import { getRequest, postRequest,postRequestLogin,putRequest,putNoToken,getRequestWithNoToken } from '../assets/js/api';

// 查询家长档案
export const _queryArchives = (params) => {
  return getRequest('/api-customer-c/psy_parent_archives', params)
}

// 保存家长档案
export const _saveArchives = (params) => {
  return postRequest('/api-customer-c/psy_parent_archives', params)
}

// 根据身份证计算生日
export const _birthdayAndAgeAndSigns = (idCard,params) => {
  return getRequest(`/api-customer-c/psy_student/birthdayAndAgeAndSigns/${idCard}`, params)
}

// 根据登录用户获取是否绑定家长信息 (true 已绑定,false未绑定)
export const _bindParentFlag = (params) => {
  return getRequest('/api-customer-c/psy_parent/bindParentFlag', params)
}

// 文件上传接口
export const _upload = (params) => {
  return postRequest('/api-file/file/upload', params)
}
